module.exports = __webpack_public_path__ + "img/icon.3cadbe29.svg";